import React from 'react';
import { useState, useMemo } from 'react';
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import styles from './../../styles/PageTitle.module.css'
import ListTable from '../utils/Table'
export default function MoviesDownload(data) {
  // console.log(Redata,"nsdfsdf")
  const location = useLocation()
  const [tableData, setTableData] = useState({
    tableTitle: "Redirect Video List",
    disableDelete: true,
    tableHead: [

      {
        id: 'name1',
        label: 'Video Name',
        isSpecial:true,
        align:"left"
      },
      {
        id: 'category_name',
        label: 'Category Name',
      },
     
      {
        id: 'video_language',
        label: 'language',
      },
      {
        id: 'video_redirect_count',
        label: 'Redirect Count',
      },
    ],
    tableBody: [

    ]
  })
  const [form, setForm] = useState({})
  const [isEdit, setIsEdit] = useState(false)
  useMemo(() => {
    if (data && Array.isArray(data.data)) { // Check if data.data is an array
      const newData = data.data.map((state) => ({
        ...state,
        name1: state?.video?.video_name?.length <= 40 ? state?.video?.video_name : state?.video?.video_name?.substring(0, 40) + "...",
        category_name: state?.video?.video_category,
        video_language: state?.video?.video_language,
        video_redirect_count: state?.count
      }));
      setTableData({ ...tableData, tableBody: newData });
    } else {
      setTableData({ ...tableData, tableBody: [] });
    }
  }, [data]);
  return (
    <>




      <ListTable tableData={tableData} key={"ListTable"} setForm={setForm} setTableData={setTableData} setIsEdit={setIsEdit} />


    </>
  );
}
